import { SET_MARKET_SUCCESS, MarketFetchSuccessAction } from './actionTypes'

export const updateMarket = (data: MarketFetchSuccessAction) => {
  return { type: SET_MARKET_SUCCESS, payload: data }
}
